import { InjectionToken } from '@angular/core';
/** Registers a statically loaded component */
export class ComponentNameAndType {
}
export function instanceOfComponentNameAndType(object) {
    return 'type' in object;
}
export function instanceOfComponentNameAndModule(object) {
    return 'module' in object;
}
export const PLACEHOLDER_COMPONENTS = new InjectionToken('Sc.placeholder.components');
export const PLACEHOLDER_LAZY_COMPONENTS = new InjectionToken('Sc.placeholder.lazyComponents');
export const PLACEHOLDER_MISSING_COMPONENT_COMPONENT = new InjectionToken('Sc.placeholder.missingComponentComponent');
export const DYNAMIC_COMPONENT = new InjectionToken('Sc.placeholder.dynamicComponent');
